import {
  WorkflowEndcustomerOneUpgradeCuComponent
} from "./workflow-endcustomer-one-upgrade-cu/workflow-endcustomer-one-upgrade-cu.component";
import {
  WorkflowEndcustomerOneUpgradeSlaComponent
} from "./workflow-endcustomer-one-upgrade-sla/workflow-endcustomer-one-upgrade-sla.component";
import {
  WorkflowEndcustomerOneDowngradeCuComponent
} from "./workflow-endcustomer-one-downgrade-cu/workflow-endcustomer-one-downgrade-cu.component";
import {
  WorkflowEndcustomerOneDowngradeSlaComponent
} from "./workflow-endcustomer-one-downgrade-sla/workflow-endcustomer-one-downgrade-sla.component";
import {WorkflowEndcustomerService} from "./workflow-endcustomer.service";
import {
  WorkflowEndcustomerOneTrialCreateComponent
} from "./workflow-endcustomer-one-trial-create/workflow-endcustomer-one-trial-create.component";
import { WorkflowEndcustomerAddTrialPhonenumberComponent } from "./workflow-endcustomer-add-trial-phonenumber/workflow-endcustomer-add-trial-phonenumber.component";
import {
  WorkflowEndcustomerOneTariffComponent
} from "./workflow-endcustomer-one-tariff/workflow-endcustomer-one-tariff.component";
import { WorkflowEndcustomerOneAvailabilityComponent } from "./workflow-endcustomer-one-availability/workflow-endcustomer-one-availability.component";
import { WorkflowEndcustomerOneAvailabilityOrderCancelComponent } from "./workflow-endcustomer-one-availability-order-cancel/workflow-endcustomer-one-availability-order-cancel.component";
import { WorkflowEndcustomerOneTariffOrderCancelComponent } from "./workflow-endcustomer-one-tariff-order-cancel/workflow-endcustomer-one-tariff-order-cancel.component";
import { WorkflowEndcustomerOneCancelPhonenumberComponent } from "./workflow-endcustomer-one-cancel-phonenumber/workflow-endcustomer-one-cancel-phonenumber.component";
import { WorkflowEndcustomerAiTariffComponent } from "./workflow-endcustomer-ai-tariff/workflow-endcustomer-ai-tariff.component";
import { WorkflowEndcustomerAiTariffOrderCancelComponent } from "./workflow-endcustomer-ai-tariff-order-cancel/workflow-endcustomer-ai-tariff-order-cancel.component";
import {
  WorkflowEndcustomerOneTrialPrepareComponent
} from "./workflow-endcustomer-one-trial-create/workflow-endcustomer-one-trial-prepare/workflow-endcustomer-one-trial-prepare.component";

export const workflowEndcustomerComponents= [
  WorkflowEndcustomerOneUpgradeCuComponent,
  WorkflowEndcustomerOneUpgradeSlaComponent,
  WorkflowEndcustomerOneDowngradeCuComponent,
  WorkflowEndcustomerOneDowngradeSlaComponent,
  WorkflowEndcustomerOneTrialCreateComponent,
  WorkflowEndcustomerAddTrialPhonenumberComponent,
  WorkflowEndcustomerOneTariffComponent,
  WorkflowEndcustomerOneAvailabilityComponent,
  WorkflowEndcustomerOneAvailabilityOrderCancelComponent,
  WorkflowEndcustomerOneTariffOrderCancelComponent,
  WorkflowEndcustomerOneCancelPhonenumberComponent,
  WorkflowEndcustomerAiTariffComponent,
  WorkflowEndcustomerAiTariffOrderCancelComponent,
  WorkflowEndcustomerOneTrialPrepareComponent
]

export const workflowEndcustomerServices = [
  WorkflowEndcustomerService,
]
